import { render, staticRenderFns } from "./FoxCoinLabel.vue?vue&type=template&id=7da898b8&scoped=true&"
import script from "./FoxCoinLabel.vue?vue&type=script&lang=js&"
export * from "./FoxCoinLabel.vue?vue&type=script&lang=js&"
import style0 from "./FoxCoinLabel.vue?vue&type=style&index=0&id=7da898b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da898b8",
  null
  
)

export default component.exports